// A plain anchor that navigates client-side. Nav hrefs are built at runtime from the nav tree, so
// they go through the router history instead of the typed <Link to> union.
import type { AnchorHTMLAttributes, MouseEvent } from "react";
import { useRouter } from "@tanstack/react-router";

export function AppLink({
  href,
  onClick,
  ...rest
}: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  const router = useRouter();
  const handle = (e: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
      return;
    e.preventDefault();
    router.history.push(href);
  };
  return <a href={href} onClick={handle} {...rest} />;
}

export function useGo() {
  const router = useRouter();
  return (href: string) => router.history.push(href);
}
